import type { LearningLabNavContext } from './learningLabNavVisibility';

export type LearningLabOffering = {
  id: string;
  title: string;
  description: string;
  roles: readonly ('coordinator')[];
  isAvailable: (ctx: LearningLabNavContext) => boolean;
};

export const COORDINATOR_LEARNING_LAB_OFFERING: LearningLabOffering = {
  id: 'coordinator-learning-lab',
  title: 'Learning Lab practice',
  description:
    'Practice with sample agency data in read-only mode. Your real agency is never changed.',
  roles: ['coordinator'],
  isAvailable: (ctx) => ctx.isCoordinator && ctx.featureEnabled,
};

/** Shown on completed lab mission rows in Help and Lab menus. */
export const LEARNING_LAB_MISSION_DONE_LABEL = 'Practice · Done';

/** Secondary hint when lab session is not active. */
export const LEARNING_LAB_ENTER_TO_START_HINT = 'Enter lab to start';

export const LEARNING_LAB_OFFERINGS: readonly LearningLabOffering[] = [
  COORDINATOR_LEARNING_LAB_OFFERING,
];

export function getAvailableLearningLabOfferings(
  ctx: LearningLabNavContext,
): LearningLabOffering[] {
  return LEARNING_LAB_OFFERINGS.filter((offering) => offering.isAvailable(ctx));
}
